import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_ACTV8_API_HOST, 
    headers: {
        common: {
            'x-api-key': process.env.REACT_APP_ACTV8_API_KEY,
            'x-api-version':  process.env.REACT_APP_ACTV8_API_VERSION,
            'Content-Type': 'application/json',
        }
    },
    timeout : process.env.REACT_APP_AXIOS_TIMEOUT_VALUE?? 10000
});

instance.interceptors.request.use(request => {
    return request;
});

export default instance;